import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Inject,
  Output,
} from '@angular/core';
import {AssetMap, ASSET_MAP} from '@core/constants/client-asset-maps';
import {RouteNames} from '@core/constants/routes';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookiesComponent {
  RouteNames = RouteNames;

  @Output()
  readonly accept = new EventEmitter<void>();

  constructor(@Inject(ASSET_MAP) readonly assetMap: AssetMap) {}
}
